const AMPLIFY_CONFIG = {
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: 'its',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-authcheck',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-authcheck`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-batches',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-batches`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-batchinfo-generator',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-batchinfo-generator`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-comp-data',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-comp-data`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-excel-generator',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-excel-generator`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-items',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-items`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-orders',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-orders`,
        region: process.env.REACT_APP_AWS_REGION,
      },
      {
        name: 'its-serials',
        endpoint: `${process.env.REACT_APP_GATEWAY_URL}/its-serials`,
        region: process.env.REACT_APP_AWS_REGION,
      },
    ],
  },
}

export default AMPLIFY_CONFIG
